export const getSessionStorageOrDefault = (key: string, defaultValue: any) => {
    const stored =
        typeof window !== 'undefined' ? sessionStorage.getItem(key) : null;
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);
};

// TODO: use new 'feature-flag-utils' library to handle this
export const isLaunchFinanceSettingsEnabled = (): boolean => {
    const { launchFinanceSettings } =
        window?.__SERVER_DATA__?.featureFlags || {};
    return Boolean(launchFinanceSettings);
};

export const getLocalStorageItemWithExpiry = (key: string): string | null => {
    try {
        const itemJSON = localStorage.getItem(key);

        if (!itemJSON) return null;

        const { expiry, value } = JSON.parse(itemJSON);
        const now = new Date();

        // * Compare the expiry time of the item with the current time
        if (now.getTime() > expiry) {
            // * If the item is expired, delete the item from storage
            localStorage.removeItem(key);

            return null;
        }

        return value;
    } catch (err) {
        return null;
    }
};

export const hasFinancialInfoUncompleted = (
    isEligibleForMissingFinancialInfoNotification: boolean,
    hasCompletedTaxpayerInformationLocally: boolean,
): boolean =>
    isEligibleForMissingFinancialInfoNotification &&
    !hasCompletedTaxpayerInformationLocally;
